import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  Container,
  Row,
  Col,
  Spinner,
} from "reactstrap";
// core components
import Select from "react-select";
import { useEffect, useState } from "react";
import axios from "axios";
import Header from "components/Headers/Header";
import Swal from "sweetalert2";
import Cookies from "universal-cookie";

const CrearSolicitud = () => {
  const cookie = new Cookies();
  useEffect(() => {
    const idUsuario = cookie.get("id");
    if (!idUsuario) {
      Swal.fire({
        icon: "warning",
        title: "Sesión no iniciada",
        text: "Debe iniciar sesión para crear una solicitud.",
        confirmButtonText: "Ir al inicio de sesión",
      }).then(() => {
        window.location.href = "/auth/login"; // Ruta de inicio de sesión
      });
    }
  }, []);

  const [postNumeroContrato, setPostNumeroContrato] = useState("");

  const [postDescripcion, setPostDescipcion] = useState("");
  const [postContrato, setPostContrato] = useState([]);
  const [list, setList] = useState([]);
  const [postProveedor, setPostProveedor] = useState("");
  const [postUsuarioAsignado, setPostUsuarioAsignado] = useState("");
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  const postConsulta = (e) => {
    Swal.fire({
      title: "Consultando",
      text: "Espere un momento",
      icon: "info",
      showConfirmButton: false,
    });

    e.preventDefault();

    axios({
      auth: {
        username: "admin.icontec@icontec.org",
        password: "quAngEraMuSTerGerEDE",
      },
      method: "get",
      url:
        "https://contratosback-dev.azurewebsites.net/api/v1/ObtenerProveedor/" +
        postProveedor,
    })
      .then((Response) => {
        Swal.close();
        if (Response.data == "") {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "La información ingresada no corresponde.",
          });
        } else {
          console.log(Response.data);
          setList(Response.data);
        }
      })
      .catch((error) => {
        Swal.close();
        Swal.fire({
          icon: "warning",
          title: "Error",
          text: "El número de identificación debe ser igual al que está en Oracle. Valide la información.",
        });
        console.log(error);
      });
  };

  useEffect(() => {
    axios({
      method: "get",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url: "https://contratosback-dev.azurewebsites.net/api/v1/AprobadoresAbastecimiento?estado=2",
    })
      .then((Response) => {
        setOptions(Response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);
  const obtenerFechaColombia = () => {
    const fecha = new Date().toLocaleDateString("es-CO", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      timeZone: "America/Bogota",
    });

    return fecha.split("/").reverse().join("-");
  };

  console.log(obtenerFechaColombia());

  console.log(obtenerFechaColombia());

  const validarCampos = () => {
    if (!postContrato || !postContrato.value) {
      Swal.fire("Campo requerido", "Seleccione el tipo de contrato", "warning");
      return false;
    }

    // Solo si el contrato es tipo 21
    if (
      postContrato.value == "21" &&
      (!postNumeroContrato || postNumeroContrato.trim() == "")
    ) {
      Swal.fire("Campo requerido", "Ingrese el número de contrato", "warning");
      return false;
    }

    if (!postProveedor || postProveedor.trim() === "") {
      Swal.fire(
        "Campo requerido",
        "Ingrese el número de documento del proveedor",
        "warning"
      );
      return false;
    }

    if (!list.length) {
      Swal.fire(
        "Proveedor no consultado",
        "Debe consultar el proveedor y obtener datos válidos",
        "warning"
      );
      return false;
    }

    if (!postUsuarioAsignado || postUsuarioAsignado === "option1") {
      Swal.fire("Campo requerido", "Seleccione un usuario asignado", "warning");
      return false;
    }

    if (!postDescripcion || postDescripcion.trim() === "") {
      Swal.fire(
        "Campo requerido",
        "Ingrese la descripción del contrato",
        "warning"
      );
      return false;
    }
    if (!postUsuarioAsignado || postUsuarioAsignado.trim() === "") {
      Swal.fire(
        "Campo requerido",
        "Selecciones un usuario a asignar",
        "warning"
      );
      return false;
    }

    return true;
  };

  const postData = (e) => {
    e.preventDefault();

    if (!validarCampos()) return;

    setLoading(true);

    axios({
      method: "post",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url: "https://contratosback-dev.azurewebsites.net/api/v1/CreaSolicitud",
      data: {
        numeroContrato: postNumeroContrato + "", // opcional
        fecha: obtenerFechaColombia(),
        nombreProveedor: list.map((item) => item.partyName).join(", "),
        nit: list.map((item) => item.nit).join(", "),
        direccion: list.map((item) => item.address1).join(", "),
        ciudad: list.map((item) => item.city).join(", "),
        telefono: list.map((item) => item.telefonoPrincipal).join(", "),
        nombreComprador: "",
        estado: "1",
        soportesId: "0",
        usuarioCreacion: cookie.get("id"),
        pasoAprobacion: "1",
        usuariosAsignacion: postUsuarioAsignado,
        compradorAsociado: postUsuarioAsignado,
        tipoUsuarioId: "0",
        idTipoContrato: postContrato.value,
        aprobacionTecnica: "0",
        idAreaSolicitante: "0",
        descripcion: postDescripcion,
      },
    })
      .then((Response) => {
        setLoading(false);
        Swal.fire({
          icon: "success",
          title: "Solicitud creada",
          text: `Código generado: ${Response.data}`,
          timer: 3000,
          showConfirmButton: false,
        }).then(() => {
          window.location.href = "/admin/Anexos/" + Response.data;
        });
      })
      .catch((error) => {
        setLoading(false);
        console.error(error);

        Swal.fire({
          icon: "error",
          title: "Error al crear solicitud",
          text: error.message || "Ocurrió un error inesperado.",
        });
      });
  };

  const stringId = list.map((item) => {
    return item.partyName;
  });
  const Nombre = stringId.join(
    list.map((item) => {
      return item.partyName;
    })
  );

  const [options1, setOptions1] = useState([]);
  useEffect(() => {
    axios({
      method: "get",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url: "https://contratosback-dev.azurewebsites.net/api/v1/ObtieneTipoContrato",
    })
      //nos da la respuesta mediante un mapeo
      .then((Response) => {
        const apiOptions = Response.data.map((item) => ({
          value: item.id,
          label: item.tipoContrato,
        }));
        setOptions1(apiOptions);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  return (
    <>
      <Header />

      <Container className="mt--7" fluid>
        <Row>
          <Col className="order-xl-1" xl="12">
            <Card className="bg-secondary shadow">
              <CardHeader className="bg-white border-0">
                <Row className="align-items-center">
                  <Col xs="8">
                    <h3 className="mb-0">Creación de solicitud</h3>
                  </Col>
                  <Col className="text-right" xs="4">
                    <Button
                      color="primary"
                      href="#pablo"
                      onClick={(e) => e.preventDefault()}
                      size="sm"
                    >
                      Settings
                    </Button>
                  </Col>
                </Row>
              </CardHeader>
              <CardBody>
                <br></br> <br></br>
                <Form>
                  <div className="pl-lg-4">
                    <Row>
                      <Col lg="6">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="select-contrato"
                          >
                            Tipo de contrato
                          </label>
                          <Select
                            id="select-contrato"
                            options={options1}
                            classNamePrefix="select"
                            onChange={setPostContrato}
                            required
                          />
                        </FormGroup>
                      </Col>

                      {postContrato?.value == "21" && (
                        <Col lg="6">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-numero-contrato"
                            >
                              Adicione número contrato
                            </label>
                            <Input
                              className="form-control-alternative"
                              id="input-numero-contrato"
                              type="text"
                              onChange={(e) =>
                                setPostNumeroContrato(e.target.value)
                              }
                            />
                          </FormGroup>
                        </Col>
                      )}
                    </Row>

                    <Row>
                      <Col lg="6">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="input-proveedor"
                          >
                            Consulte proveedor
                          </label>
                          <Input
                            className="form-control-alternative"
                            id="input-proveedor"
                            type="text"
                            onChange={(e) => setPostProveedor(e.target.value)}
                          />
                        </FormGroup>
                      </Col>
                      <Col lg="6">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="btn-consultar"
                          >
                            Clic para consultar por número de documento
                          </label>
                          <div>
                            <button
                              id="btn-consultar"
                              className="btn btn-primary"
                              type="button"
                              onClick={postConsulta}
                            >
                              Consultar
                            </button>
                          </div>
                        </FormGroup>
                      </Col>
                    </Row>

                    <Row>
                      <Col lg="12">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="input-nombre-proveedor"
                          >
                            Nombre del Proveedor
                          </label>
                          <Input
                            className="form-control-alternative"
                            id="input-nombre-proveedor"
                            value={list
                              .map((item) => item.partyName)
                              .join(", ")}
                            type="text"
                            disabled
                          />
                        </FormGroup>
                      </Col>
                    </Row>

                    <Row>
                      <Col lg="6">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="input-nit"
                          >
                            Tipo de documento
                          </label>
                          <Input
                            className="form-control-alternative"
                            id="input-nit"
                            value={list.map((item) => item.nit).join(", ")}
                            type="text"
                            disabled
                          />
                        </FormGroup>
                      </Col>

                      <Col lg="6">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="input-direccion"
                          >
                            Dirección
                          </label>
                          <Input
                            className="form-control-alternative"
                            id="input-direccion"
                            value={list.map((item) => item.address1).join(", ")}
                            type="text"
                            disabled
                          />
                        </FormGroup>
                      </Col>
                    </Row>

                    <Row>
                      <Col lg="6">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="input-ciudad"
                          >
                            Ciudad
                          </label>
                          <Input
                            className="form-control-alternative"
                            id="input-ciudad"
                            value={list.map((item) => item.city).join(", ")}
                            type="text"
                            disabled
                          />
                        </FormGroup>
                      </Col>

                      <Col lg="6">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="input-telefono"
                          >
                            Teléfono
                          </label>
                          <Input
                            className="form-control-alternative"
                            id="input-telefono"
                            value={list
                              .map((item) => item.telefonoPrincipal)
                              .join(", ")}
                            type="number"
                            disabled
                          />
                        </FormGroup>
                      </Col>
                    </Row>

                    <Row>
                      <Col lg="12">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="select-usuario"
                          >
                            Asignación de usuario
                          </label>
                          <Input
                            id="selected-usuario"
                            type="select"
                            onChange={(e) =>
                              setPostUsuarioAsignado(e.target.value)
                            }
                            required
                          >
                            <option value="option1">
                              Seleccione el usuario
                            </option>
                            {options.map((item) => (
                              <option key={item.id} value={item.id}>
                                {item.nombre}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>
                      </Col>
                    </Row>

                    <Row>
                      <Col lg="12">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="input-descripcion"
                          >
                            Objeto o descripción del contrato
                          </label>
                          <Input
                            className="form-control-alternative"
                            id="input-descripcion"
                            type="textarea"
                            onChange={(e) => setPostDescipcion(e.target.value)}
                            required
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row className="mt-4">
                      <Col>
                        <button
                          className="btn btn-primary btn-lg"
                          type="button"
                          onClick={postData}
                          disabled={loading}
                        >
                          {loading ? <Spinner size="sm" /> : "ENVIAR"}
                        </button>
                      </Col>
                    </Row>
                  </div>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default CrearSolicitud;
